export default {
  'primary': '#054375',
  'secondary': '#05bdfb',
  'accent': '#05e6fb',
  'area_cliente': {
    'primary': '#05bdfb',
    'secondary': '#054375',
    'accent': '#054375'
  }
}
